import { defineMessages } from '@transcend-io/internationalization';

export const avatarPopoverMessages = defineMessages(
  'privacy-center.components.AvatarPopover.avatarPopover',
  {
    statusId: {
      defaultMessage: 'Verified ID',
    },
    statusNickname: {
      defaultMessage: 'Verified',
    },
    endSession: {
      defaultMessage: 'End Session',
    },
    profileMenuLabel: {
      defaultMessage: 'Profile settings menu',
    },
    avatarAlt: {
      defaultMessage: 'Your profile icon',
    },
    avatarAltWithNickname: {
      defaultMessage: "{nickname}'s profile icon",
    },
  },
);
